import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  adminAgentService,
  type AdminActionHistoryFilters,
} from '../../../../services/adminAgent.service';

export function useAdminActionHistory(filters: AdminActionHistoryFilters) {
  return useQuery({
    queryKey: ['admin-agent', 'history', filters],
    queryFn: () => adminAgentService.listHistory(filters),
    placeholderData: keepPreviousData,
  });
}
